import { useMutation } from 'react-query';
import { DeelprojectDto } from '../../../../codegen/SwaggerProduct';
import { getProductReservationApi } from '../../../../config/SwaggerProductReservationApi';

const updateDGManagement = (project: DeelprojectDto) =>
    getProductReservationApi()
        .deelproject.updateUpdate(project)
        .then((response) => response.data);

const useUpdateDGManagement = () => {
    const useUpdateDGManagementMutation = useMutation(updateDGManagement);

    return useUpdateDGManagementMutation;
};

export default useUpdateDGManagement;
